import axios from "axios";
import store from "./store";
import router from "./router";
import { Toast } from "cube-ui";

// eslint-disable-next-line no-unused-vars
const baseURL = process.env.NODE_ENV === "production" ? "" : "/api";
// 创建 axios 实例
const service = axios.create({
  baseURL: baseURL, // api base_url
  timeout: 5000 // 请求超时时间
});
service.interceptors.request.use(config => {
  store.state.token ? (config.headers.token = store.state.token) : "";
  return config;
});
service.interceptors.response.use(response => {
  const { data, status } = response;
  // status = 400
  if (status === 200) {
    store.commit("changeNetworkSuccess", true);
    if (data.code === 203 || data.code === 200) return data;
    if (data.code === 0 || !data.code) {
      return data;
    } else if (data.code !== 1) {
      let msg = data.msg || "网络异常";
      // console.log(msg)
      Toast.$create({
        txt: msg,
        type: "txt"
      }).show();
      return data;
    }
  }
  return response;
});

function checkCode(res) {
  if (res.status == 401) {
    router.push({ path: "login" });
  } else {
    router.push({ path: "refresh" });
    store.commit("changeNetworkSuccess", false);
    Toast.$create({
      txt: "服务器错误，请检查网络",
      type: "txt"
    }).show();
  }
  //return res;
}

export default {
  post(url, data, loading) {
    // if (loading) {
    //   Spin.show();
    // }
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        data: data,
        timeout: 30000,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          token: localStorage.token || ""
        }
      })
        .then(res => {
          // eslint-disable-next-line no-undef
          // if (res.code === 0 || !res.code) {
          resolve(res);
          // }
        })
        .catch(err => {
          // alert(err)
          checkCode(err);
          reject(err);
        });
    });
  },
  get(url, params, loading) {
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        params, // get 请求时带的参数
        timeout: 30000,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/x-www-form-urlencoded",
          token: localStorage.token || ""
        }
      })
        .then(res => {
          // if (res.code === 0 || !res.code) {
          resolve(res);
          // }
        })
        .catch(err => {
          // alert(err)
          checkCode(err);
          reject(err);
        });
    });
  }
};
